
export const FA_msgs = {
    'bad email format': 'فرمت ایمیل معتبر نیست',
    'invalid input': 'ورودی نامعتبر است',
    'The number is too large': 'مقدار بسیار بزرگ است',
    'The number is too small': 'مقدار بسیار کوچک است',
    'The maximum number of characters is not respected': 'حداکثر تعداد کاراکترها رعایت نمی شود',
    'The minimum number of characters is not met': 'حداقل تعداد کاراکترها رعایت نمی شود',
    'required field': 'فیلد الزامی است',
    'number field': 'فیلد تنها عدد میپذیرد',
    'field value is invalid': 'مقدار فیلد نامعتبر است',
    'Upload files here...': 'فایل ها رو اینجا بارگذاری کنید ...',
    'Upload Completed': 'بارگذاری با موفقیت انجام شد',
    'uploading ...': 'در حال بارگذاری...',
    'starting ...': 'شروع بارگذاری ...',
    'max files limit is $1': 'حداکثر تعداد فایل مورد قبول $1 است',
    'max file size limit is $1 (your file size is $2)': 'حداکثر حجم مورد قبول $1 است (حجم فایل شما $2 است)',
    'Error occurred while uploading file': 'خطایی در بارگذاری رخ داده است',

    'Insert image': 'افزودن تصویر',
    'Headings': 'عناوین',
    'Line': 'خط افقی',
    'Bold': 'پررنگ',
    'Insert table': 'افزودن جدول',
    'OK': 'باشه',
    'Cancel': 'انصراف',
    'Description': 'توضیحات',
    'Select image file': 'انتخاب فایل تصویری',
    'File': 'فایل',
    'URL': 'آدرس‌اینترنتی',
    'Insert link': 'افزودن لینک',
    'Scroll': 'پیمایش',
    'Ordered list': 'لیست مرتب شده',
    'Unordered list': 'لیست نامرتب',
    'Inline code': 'کد درون خطی',
    'Insert codeBlock': 'درج کد بلوک',
    'Image URL': 'آدرس اینترنتی تصویر',
    'Choose a file': 'انتخاب فایل',
    'Link text': 'متن لینک',
    'Blockquote': 'نقل قول',
    'Task': 'چک لیست',
    'Strike': 'خط زدن',
    'Italic': 'خط کج',

}